// DragAndDropTarget.js
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography } from '@mui/material';
import { PropTypes } from 'prop-types';

const DragAndDropTarget = ({ onFileUpload, message}) => {
  const onDrop = (acceptedFiles) => {
    // Do something with the dropped file
    if (acceptedFiles.length > 0) {
      onFileUpload(acceptedFiles);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <Box className="DragAndDropTarget"
      {...getRootProps()}
      sx={{
        border: '2px dashed #bdbdbd',
        padding: '2rem',
        textAlign: 'center',
        cursor: 'pointer'
      }}
    >
      <input {...getInputProps()} />
      <Typography variant="body1">{message}</Typography>
    </Box>
  );
};

DragAndDropTarget.propTypes = {
  onFileUpload: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired
};

export default DragAndDropTarget;
